export default {
  language: {
    zh: '语言',
    en: 'Language',
  },
  listPage: {
    zh: '列表页',
    en: 'List',
  },
  name: {
    zh: '名称',
    en: 'Name',
  },
  type: {
    zh: '类型',
    en: 'Type',
  },
  version: {
    zh: '版本',
    en: 'Version',
  },
  operations: {
    zh: '操作',
    en: 'Operations',
  },
  create: {
    zh: '创建',
    en: 'Create',
  },
  view: {
    zh: '查看',
    en: 'View',
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
  },
  delete: {
    zh: '删除',
    en: 'Delete',
  },
  update: {
    zh: '更新',
    en: 'Update',
  },
  upload: {
    zh: '上传',
    en: 'Upload',
  },
  uploadSuccess: {
    zh: '上传成功',
    en: 'Upload successfully',
  },
  submit: {
    zh: '提交',
    en: 'Submit',
  },
  add: {
    zh: '添加',
    en: 'Add',
  },
  cancel: {
    zh: '取消',
    en: 'Cancel',
  },
  addSuccess: {
    zh: '添加成功',
    en: 'Added successfully',
  },
  createSuccess: {
    zh: '创建成功',
    en: 'Create successfully',
  },
  confirmDelete: {
    zh: '确认删除吗？',
    en: 'Confirm delete?',
  },
  deleteSuccess: {
    zh: '删除成功',
    en: 'Delete successfully',
  },
  editSuccess: {
    zh: '编辑成功',
    en: 'Edit successfully',
  },
  restartSuccess: {
    zh: '重启成功',
    en: 'Restart successfully',
  },
  warning: {
    zh: '警告',
    en: 'Warning',
  },
  ok: {
    zh: '确认',
    en: 'OK',
  },
  status: {
    zh: '状态',
    en: 'Status',
  },
  restart: {
    zh: '重启',
    en: 'Restart',
  },
  stop: {
    zh: '停止',
    en: 'Stop',
  },
  start: {
    zh: '启动',
    en: 'Start',
  },
  startSuccess: {
    zh: '启动成功',
    en: 'Start successfully',
  },
  stopSuccess: {
    zh: '停止成功',
    en: 'Stop successfully',
  },
  updateSuccess: {
    zh: '更新成功',
    en: 'Updated successfully',
  },
  login: {
    zh: '登 录',
    en: 'LOG IN',
  },
  logout: {
    zh: '退出登录',
    en: 'Logout',
  },
  username: {
    zh: '用户名',
    en: 'Username',
  },
  password: {
    zh: '密码',
    en: 'Password',
  },
  remember: {
    zh: '记住',
    en: 'Remember',
  },
  usernameRequried: {
    zh: '用户名不能为空',
    en: 'Please fill in the Username',
  },
  passwordRequired: {
    zh: '密码不能为空',
    en: 'Please fill in the password',
  },
  fillContent: {
    zh: '请填写内容',
    en: 'Please fill in the content',
  },
  changePassword: {
    zh: '修改密码',
    en: 'Change password',
  },
  oldPassword: {
    zh: '旧密码',
    en: 'Old password',
  },
  newPassword: {
    zh: '新密码',
    en: 'New password',
  },
  confirmPassword: {
    zh: '确认密码',
    en: 'Confirm password',
  },
  pleaseEnterYourPasswordAgain: {
    zh: '请再次输入密码',
    en: 'Please enter your password again',
  },
  confirmNotMatch: {
    zh: '两次输入密码不一致',
    en: 'The two input passwords do not match',
  },
  changePasswordSuccess: {
    zh: '密码修改成功，请重新登录',
    en: 'The modification is successful, please log in again',
  },
  selectCurrentNode: {
    zh: '请先选择当前使用的服务',
    en: 'Please select the service you need to use first',
  },
  day: {
    zh: '天',
    en: 'days',
  },
  hour: {
    zh: '时',
    en: 'hours',
  },
  min: {
    zh: '分',
    en: 'minutes',
  },
  seconds: {
    zh: '秒',
    en: 'seconds',
  },
  documentation: {
    zh: '使用文档',
    en: 'Documentation',
  },
  advanced: {
    zh: '高级',
    en: 'Advanced',
  },
  description: {
    zh: '描述',
    en: 'Description',
  },
  trial: {
    zh: '试用版',
    en: 'Trial',
  },
  yes: {
    zh: '是',
    en: 'Yes',
  },
  no: {
    zh: '否',
    en: 'No',
  },
  key: {
    zh: '键',
    en: 'Key',
  },
  value: {
    zh: '值',
    en: 'Value',
  },
  install: {
    zh: '安装',
    en: 'Install',
  },
  none: {
    zh: '无',
    en: 'None',
  },
  invalidateForm: {
    zh: '未验证表单',
    en: 'Invalidate Form',
  },
  createdAt: {
    zh: '创建时间',
    en: 'Created At',
  },
  updateAt: {
    zh: '更新时间',
    en: 'Update At',
  },
  forExample: {
    zh: '例如{value}',
    en: 'For example {value}',
  },
  testConnection: {
    zh: '测试连接',
    en: 'Test Connection',
  },
  TestConnectionSuccess: {
    zh: '测试连接成功',
    en: 'Test connection successfully',
  },
  TestConnectionfailed: {
    zh: '测试连接失败',
    en: 'Test connection failed',
  },
  copy: {
    zh: '复制',
    en: 'Copy',
  },
  copySuccess: {
    zh: '复制成功',
    en: 'Copy successfully',
  },
  back: {
    zh: '返回',
    en: 'Back',
  },
  file: {
    zh: '文件',
    en: 'File',
  },
  text: {
    zh: '文本',
    en: 'Text',
  },
  apiError: {
    zh: '接口报错',
    en: 'API Error',
  },
  running: {
    zh: '运行中',
    en: 'Running',
  },
  stoped: {
    zh: '已停止',
    en: 'Stopped',
  },
  loading: {
    zh: '加载中',
    en: 'Loading',
  },
  starting: {
    zh: '正在启动',
    en: 'Starting',
  },
  stopping: {
    zh: '正在停止',
    en: 'Stopping',
  },
  restarting: {
    zh: '正在重启',
    en: 'Restarting',
  },
}
